export enum ContentfulTags {
  FEATURED = 'featured',
  MEDICARE_101 = 'medicare101',
  DOES_MEDICARE_COVER = 'doesMedicareCover',
  FAIR_SQUARE_UPDATES = 'fairSquareUpdates',
  PRIVATE = 'private',
}
